import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

function CancelVisitModal({ show, visit, onHide, onConfirm, isSubmitting }) {
  const [cancelReason, setCancelReason] = useState('');

  useEffect(() => {
    if (show) {
      setCancelReason('');
    }
  }, [show, visit?.id]);

  const handleClose = () => {
    if (isSubmitting) return;
    onHide();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = cancelReason.trim();
    if (trimmed.length < 5) {
      toast.error('Please enter a cancellation reason (at least 5 characters).');
      return;
    }
    onConfirm(trimmed);
  };

  const trimmedLength = cancelReason.trim().length;
  const isValid = trimmedLength >= 5;

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={!isSubmitting}>
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title>Cancel Visit Request</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="text-muted mb-3">
            You are about to cancel{' '}
            <strong>{visit?.serviceType || 'this visit request'}</strong>
            {visit?.preferredDate ? (
              <>
                {' '}
                scheduled for <strong>{visit.preferredDate}</strong> at{' '}
                <strong>{visit.preferredTime}</strong>.
              </>
            ) : (
              '.'
            )}
          </p>
          <label htmlFor="cancelReason" className="form-label">
            Reason for cancellation <span className="text-danger">*</span>
          </label>
          <textarea
            id="cancelReason"
            className="form-control"
            rows={4}
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            placeholder="Please tell us why you are cancelling this request..."
            maxLength={500}
            required
            disabled={isSubmitting}
          />
          <small className="form-text text-muted d-block text-end">
            {trimmedLength}/500 characters (minimum 5)
          </small>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn cancel-btn"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Back
          </button>
          <button
            type="submit"
            className="btn btn-danger"
            disabled={isSubmitting || !isValid}
          >
            {isSubmitting ? 'Cancelling...' : 'Confirm Cancellation'}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default CancelVisitModal;
